exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 767px){\n.layout-default .main-content, .layout-icon-sidebar .main-content {\r\n    margin: 50px 0 0 0;\n}\n}\r\n\r\n", ""]);

// exports
